import FormService from "../../services/FormService";

export default {

    data() {
        return {
            form: new FormService({
                id: null,
                booking_fee: null,
                cashier_reserve_seat_more_than_one_permission: null,
                passenger_reserve_seat_more_than_one_permission: null,
                reserved_seats_remove_before_departure_in_minutes: null,
                one_seat_reserve_passenger_data: null,
                more_seat_reserve_passenger_data: null,
                reserved_places_remove_in_minutes: null,
            }),
        }

    },
    methods: {
        getBookingSettings(){
            this.$api.get('settings.booking-index')
                .then(result => {
                    this.form.id = result.data.id;
                    this.form.booking_fee = result.data.booking_fee;
                    this.form.cashier_reserve_seat_more_than_one_permission = result.data.cashier_reserve_seat_more_than_one_permission;
                    this.form.passenger_reserve_seat_more_than_one_permission = result.data.passenger_reserve_seat_more_than_one_permission;
                    this.form.reserved_seats_remove_before_departure_in_minutes = result.data.reserved_seats_remove_before_departure_in_minutes;
                    this.form.one_seat_reserve_passenger_data = result.data.one_seat_reserve_passenger_data;
                    this.form.more_seat_reserve_passenger_data = result.data.more_seat_reserve_passenger_data;
                    this.form.reserved_places_remove_in_minutes = result.data.reserved_places_remove_in_minutes;
                })
        },
        saveSettings(){
            this.form.put('settings.booking-update', this.form.id)
                .then(res => {
                    if (!res.errors) {
                        this.$notify({
                            type: 'success',
                            group: 'foo',
                            title: 'Успешно!!!',
                            text: this.i18n('Settings saved!')
                        });
                    } else {
                        this.$notify({
                            type: 'error',
                            group: 'foo',
                            title: 'ООПС!!!',
                            text: res.errors[0]
                        });
                    }
                })
        }
    },
    created(){
        this.getBookingSettings();
    },
    mounted(){},
}